import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';
import DashboardPage from './DashboardPage';
import MessagesPage from './MessagesPage';
import UtilisateursPage from './UtilisateursPage';
import api from '../utils/api';

const AdminLayout = () => {
    const [page, setPage] = useState('dashboard');
    const [pendingCount, setPendingCount] = useState(0);
    const { admin } = useAuth();

    useEffect(() => {
        api.get('/messages/stats')
            .then(({ data }) => setPendingCount(data.stats?.en_attente || 0))
            .catch(() => { });
    }, [page]);

    const pageConfig = {
        dashboard: { title: 'Tableau de bord', subtitle: 'Vue générale des activités' },
        messages: { title: 'Tous les messages', subtitle: 'Gestion des messages clients' },
        reclamations: { title: 'Réclamations', subtitle: 'Messages de type réclamation' },
        suggestions: { title: 'Suggestions', subtitle: 'Propositions des clients' },
        satisfactions: { title: 'Satisfactions', subtitle: 'Retours positifs des clients' },
        utilisateurs: { title: 'Utilisateurs', subtitle: 'Gestion des comptes utilisateurs' },
    };

    const typeMap = {
        reclamations: 'reclamation',
        suggestions: 'suggestion',
        satisfactions: 'satisfaction',
    };

    const current = pageConfig[page] || pageConfig.messages;

    const renderPage = () => {
        if (page === 'dashboard') return <DashboardPage />;
        if (page === 'utilisateurs') {
            return admin?.role === 'super_admin'
                ? <UtilisateursPage />
                : <div style={{ color: 'rgba(255,255,255,0.5)', textAlign: 'center', padding: 60, fontSize: 16 }}>⛔ Accès réservé au Super Admin</div>;
        }
        return <MessagesPage filterType={typeMap[page]} readOnly={admin?.role === 'visiteur'} />;
    };

    return (
        <div style={{ display: 'flex', minHeight: '100vh', background: 'linear-gradient(135deg,#0a1628 0%,#0f2744 100%)' }}>
            <Sidebar page={page} setPage={setPage} pendingCount={pendingCount} />
            <div style={{ marginLeft: 260, flex: 1, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                <div style={{ background: 'rgba(255,255,255,0.02)', backdropFilter: 'blur(20px)', borderBottom: '1px solid rgba(0,212,255,0.1)', padding: '0 32px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 50 }}>
                    <div>
                        <div style={{ fontSize: 18, fontWeight: 700, color: 'white' }}>{current.title}</div>
                        <div style={{ fontSize: 13, color: 'rgba(0,212,255,0.6)', marginTop: 1 }}>{current.subtitle}</div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        {pendingCount > 0 && (
                            <div style={{ background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 10, padding: '7px 14px', fontSize: 13, color: '#f87171', fontWeight: 600, boxShadow: '0 0 15px rgba(239,68,68,0.1)' }}>
                                🔔 {pendingCount} message(s) en attente
                            </div>
                        )}
                        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.3)' }}>
                            {new Date().toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                        </div>
                    </div>
                </div>
                <div style={{ padding: 32, flex: 1 }}>{renderPage()}</div>
            </div>
        </div>
    );
};

export default AdminLayout;